function getString(key: string, fallback = ''): string {
  return (import.meta.env[key] as string | undefined) ?? fallback;
}

function getList(key: string, fallback: string[] = []): string[] {
  const raw = (import.meta.env[key] as string | undefined)?.trim();
  if (!raw) return fallback;
  return raw
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

export const env = {
  VITE_APP_NAME: getString('VITE_APP_NAME', 'Money Fox'),

  // Application backend
  VITE_API_URL: getString('VITE_API_URL', 'https://api.moneyfox.io'),

  // Turbopay settlements catalog + filing
  VITE_TURBOPAY_API_URL: getString(
    'VITE_TURBOPAY_API_URL',
    'https://turbopay-api.license-321.workers.dev',
  ),

  // Firebase
  VITE_FIREBASE_API_KEY: getString('VITE_FIREBASE_API_KEY'),
  VITE_FIREBASE_AUTH_DOMAIN: getString('VITE_FIREBASE_AUTH_DOMAIN'),
  VITE_FIREBASE_APP_ID: getString('VITE_FIREBASE_APP_ID'),

  // Payments
  VITE_PAYMENT_API_URL: getString('VITE_PAYMENT_API_URL'),
  VITE_PAYPAL_CLIENT_ID: getString('VITE_PAYPAL_CLIENT_ID'),

  // Products / Subscriptions
  /** Checkout plan ids when no `plan`/`plans` URL or funnel-config params are present. */
  VITE_DEFAULT_PLAN_IDS: getList('VITE_DEFAULT_PLAN_IDS', [
    'moneyfox_7d1499',
    'moneyfox_3d299_7d1999',
    'moneyfox_1y11999',
  ]),
  VITE_PLANS_API_URL: getString(
    'VITE_PLANS_API_URL',
    'https://product-service-dot-analytics-203419.uc.r.appspot.com/plans',
  ),
  VITE_SUBSCRIPTIONS_API_URL: getString('VITE_SUBSCRIPTIONS_API_URL'),
  VITE_SUBSCRIPTION_BUNDLE: getString('VITE_SUBSCRIPTION_BUNDLE', 'com.devroq.turbopay'),

  // Geo (defaults to Cloudflare trace — plain-text key=value endpoint)
  VITE_GEO_API_URL: getString('VITE_GEO_API_URL', 'https://www.cloudflare.com/cdn-cgi/trace'),

  // Config-driven funnel: GET {url}/{configId} -> { url?, params }
  VITE_CONFIG_API_URL: getString('VITE_CONFIG_API_URL'),
  VITE_CONFIG_ID_PREFIX: getString('VITE_CONFIG_ID_PREFIX', 'cfg_'),

  // Analytics
  VITE_GA_MEASUREMENT_ID: getString('VITE_GA_MEASUREMENT_ID'),
  VITE_FB_PIXEL_ID: getString('VITE_FB_PIXEL_ID', '1527070512057000'),

  // Native app store listings (Get App step after purchase)
  VITE_APP_STORE_URL: getString(
    'VITE_APP_STORE_URL',
    'https://apps.apple.com/us/app/moneyfox-claim-finder/id6805409705',
  ),
  VITE_PLAY_STORE_URL: getString(
    'VITE_PLAY_STORE_URL',
    'https://play.google.com/store/apps/details?id=com.galaxyline.moneyfox&pli=1',
  ),

  // Trustpilot / Rate Us
  VITE_REVIEW_URL: getString('VITE_REVIEW_URL'),

  // Refund request form
  VITE_REFUND_URL: getString('VITE_REFUND_URL'),

  // Monitoring
  VITE_SENTRY_DSN: getString('VITE_SENTRY_DSN'),
};
